import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { CommonService } from '@shared/services/common.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

@Component({
    selector: 'app-global-vocabulary-rules',
    templateUrl: './global-vocabulary-rules.component.html',
    styleUrls: ['./global-vocabulary-rules.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatButton]
})
export class GlobalVocabularyRulesComponent implements OnInit {

  public vocabularyRulesForm = this._fb.nonNullable.group({
    rules: ['', [Validators.required, Validators.min(10)]],
  });

  constructor(
    private _metadataService: MetadataService,
    private _fb: FormBuilder,
    private _commonService: CommonService,
  ) {
  }

  ngOnInit() {
    this.get();
  }

  submit() {
    this._metadataService.set(
      MetadataSlugs.GlobalVocRules,
      this.vocabularyRulesForm.value.rules!.toString(),
    ).subscribe({
      error: err => {
        console.error(err);
      },
      next: () => {
        this._commonService.openSuccessSnackBar('Updated successfully');
      },
    });
  }

  get() {
    this._metadataService.get<string>(MetadataSlugs.GlobalVocRules).subscribe(value => {
      this.vocabularyRulesForm.patchValue({ rules: value.value! });
    });
  }
}
